gsap.registerPlugin(ScrollTrigger);

document.querySelectorAll(".kg-text-content").forEach((section) => {
  // Set the ScrollTrigger and animation for each section
  gsap.timeline({
    scrollTrigger: {
      trigger: section, 
      start: "top 80%",
      end: "bottom bottom",
      toggleActions: "play none none reverse"
    }
  })
  .from(section.querySelector("h1.kg-text-h1"), { opacity: 0, y: 20, duration: 1 }) 
  .from(section.querySelector("h2.kg-text-h2"), { opacity: 0, y: 20, duration: 1 }, "-=0.5") 
  .from(section.querySelector("p.kg-text-p"), { opacity: 0, y: 20, duration: 1 }, "-=0.5"); 
});
